import { useAtomValue } from 'jotai';

import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { SEATS } from '@core/Constants/Filters/SeatsFilter.constants';
import { MultiSelect } from '@plp/Components/MultiSelect/MultiSelect';
import { getOptionsWithAggs } from '@plp/Utils/Filters/GetOptionsWithAggs';
import { useMultiSelectFilters } from '@search-filters/Hooks/UseMultiSelectFilters';

import type { FilterControlBaseProps } from '../../FilterPanel.entity';
import ApplyButton from '../ApplyButton/ApplyButton';

import styles from './SeatsFilter.module.css';

type SeatsFilterProps = FilterControlBaseProps;

export const SeatsFilter = ({
  strings,
  isPlpFiltersSeoEnabled,
  tenant,
  applyButton = false,
}: SeatsFilterProps) => {
  const { seats } = useAtomValue(aggregationsAtom);

  const { handleSelect, handleApply, listWithSelected } = useMultiSelectFilters(
    'seats',
    getOptionsWithAggs(SEATS, seats),
    strings,
    isPlpFiltersSeoEnabled,
    tenant,
    undefined,
    applyButton,
  );

  return (
    <section className={styles.seatsFilter}>
      <MultiSelect
        groupName="seats"
        classes={{ label: styles.listItem }}
        items={listWithSelected}
        onSelect={(id, checked) => {
          handleSelect(id, checked);
        }}
        dataTestId="seats-filter-list"
        applyButton={applyButton}
      />
      {applyButton && <ApplyButton handleApply={handleApply} ctaText={strings.apply} />}
    </section>
  );
};
